import { render, staticRenderFns } from "./OnboardingController.vue?vue&type=template&id=593f0fc0&"
import script from "./OnboardingController.vue?vue&type=script&lang=js&"
export * from "./OnboardingController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports